import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConstantService} from '../../constant/constant.service'

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    public constantService: ConstantService,
    public http: HttpClient
  ) {
  }

  login(body: Object) {
    return this.http.post(this.constantService.getUrl(this.constantService.LOGIN), body);
  }

  forgetPassword(body: Object) {
    return this.http.post(this.constantService.getUrl(this.constantService.FORGETPASSWORD), body);
  }

  resetPassword(body, token) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.RESETPASSWORD}/resetpassword`, [token]), body);
  }

  logout() {
    return this.http.post(this.constantService.getUrl(this.constantService.LOGOUT), {});
  }

  paymentDetails(token) {
    return this.http.get(this.constantService.getUrl(`${this.constantService.BITLY}/payment/${token}/details`));
  }

  sendOtp(body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.AUTH}/sendOtp`), body);
  }

  loginWithOTP(body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.AUTH}/validateotp`), body);
  }

  changePassword(body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.AUTH}/changepassword`), body);
  }

}
